import React, { useCallback, useState, useEffect } from 'react';
import { Button, View, Text, SafeAreaView, Dimensions, StyleSheet, FlatList, ActivityIndicator, TouchableOpacity } from 'react-native-web';

import { connect, useDispatch, useSelector } from "react-redux";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { fetchResourcesFromApi, fetchMoreResourcesFromApi } from "../../shared/actions/ResourcesActions";
import { GetAppointmentDate, GetMonthName, GetYear } from '../../shared/core/datehelper'
import { Viewer } from '@react-pdf-viewer/core';
import { Card, Col, Modal, Row } from 'antd';
import ResourcesHandler from "../components/ResourcesHandler";
import "../components/css/drive.css";
import { fetchProfileFromApi } from '../../shared/actions/ProfileActions';
import getUserInfo from '../../shared/core/GetTokenized';
import { appServices } from '../../shared/redux/actions/appServices';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
const gridStyle = {
    width: '50%',
    textAlign: 'center',
};
const renderToolbar = (Toolbar) => (
    <>
        <Toolbar />
        <div
            style={{
                borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                marginTop: '4px',
                padding: '4px',
            }}
        >
            Custom element
        </div>
    </>
);
const ResourcesHome = props => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin(
        renderToolbar
    );
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
      const PatienInformation = JSON.parse(information);
    // const { Resources, isGetting } = props.Resources;
    const { Resources, isGetting } = useSelector((state)=> state.Media)
    // const { Profile, isFetching } = props.Profile;
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const [pageSize, setPageSize] = useState(100);           //state for the page number
    const [pageNumber, setPageNumber] = useState(1);
    const [isloaded, setIsload] = React.useState(false);
    const [pdfVisible, setPdfVisible] = useState(false);
    const [isLoadingPdf, setIsLoadingPdf] = useState(false);
    const [file, setFile] = React.useState()
    const {MediaByIDData , isMediaByIDData}=useSelector((state)=>state.MediaByID)
    const dispatch= useDispatch()
    React.useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://indici-pre-production.web.app/assets/js/template.js";
        document.body.appendChild(script)
        // d.div.appendChild(script);
    }, [])
    const ResObj={
        PatientID: Profile && Profile[0].resource.id,
        PageNumber: pageNumber,
        pageSize : pageSize, 
    }
    const base64toBlob = (data) => {
        // Cut the prefix `data:application/pdf;base64` from the raw base 64
        const base64WithoutPrefix = data.substr('data:application/pdf;base64,'.length);

        const bytes = atob(base64WithoutPrefix);
        let length = bytes.length;
        let out = new Uint8Array(length);

        while (length--) {
            out[length] = bytes.charCodeAt(length);
        }

        return new Blob([out], { type: 'application/pdf' });
    };
    useEffect(() => {
       if(Profile) dispatch(appServices.Media(ResObj))
        // props.getResources(pageSize, pageNumber);
    }, [Profile])


    const checkItems = resourceInfo => {
        alert('yooyoyoyoy')
    }
    useEffect(() => {
        if(MediaByIDData){
           console.log(MediaByIDData , "MediaByIDData")
           if (MediaByIDData[0].resource.content.contentType == "PDF") {

               setPdfVisible(true)
               // console.log('Hello:', json[0].entry[0].resource.resourceType)
               //alert(json[0].entry[0].resource.resourceType);
               var b64 = MediaByIDData[0].resource.content.data;
               // var bin = atob(b64);
   
               // // Embed the PDF into the HTML page and show it to the user
               var obj = document.createElement('object');
               obj.style.width = '100%';
               obj.style.height = '550px';
               obj.type = 'application/pdf';
               obj.data = 'data:application/pdf;base64,' + b64;
               //document.body.appendChild(obj);
   
               // `base64String` is the given base 64 data
               const blob = base64toBlob("data:application/pdf;base64," + MediaByIDData[0].resource.content.data);
               const url = URL.createObjectURL(blob);
            //    console.log("Blob size:", blob.size);
               if (blob && blob.type === 'application/pdf') {
    const url = URL.createObjectURL(blob);
    // console.log("Blob URL created:", url);
// window.open(url, '_blank');
    setFile(url);
} else {
    // console.error("Invalid blob:", blob);
}
            //    setFile(url)
            //    setFile((state) => {
            //        return state;
            //    });
               // document.getElementById("showPDF").appendChild(obj)
               setIsLoadingPdf(false);
   
               return
           } else {
             
           }  
        }
       }, [MediaByIDData])
    return (
        <div>
            {/* <Header />
            <div id="myphonemenu" className="page-body">
                <Sidebar /> */}
                <div className="page-content-wrapper">
                    <div className="page-content-wrapper-inner">
                        <div className="viewport-header">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb has-arrow">
                                    <li className="breadcrumb-item">
                                        <a href="#">Dashboard</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Resources</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="content-viewport">
                            <div className="row">
                                <div className="col-12">
                                    <div className="grid">
                                        <div className="grid-body">
                                            <h2 className="grid-title">Resources</h2>
                                            <div className="item-wrapper">
                                                {/* <div className="row mb-2">
                                                    <div className="col-md-8 mx-auto">
                                                        <div className="alert alert-warning" role="alert">
                                                            <h6 className="alert-heading">Please Note:</h6> */}
                                                            {/* {isFetching && <ActivityIndicator color='blue' size='small' />} */}
                                                            {
                                                                 Profile  && Profile.length ? (
                                                                    // <p>{Profile[0].resource.extension[9].hasOwnProperty('valueString') ? Profile[0].resource.extension[9].valueString :"N/A" }</p>
                                                                    Profile[0].resource.extension.map((item, index) => {

                                                                        return (
                                                                            item.url == "ResourceDisclaimer" &&
                                                                            <div className="row mb-2">
                                                                            {isFetching && <ActivityIndicator color='blue' size='small' />}
                                                                      <div className="col-md-8 mx-auto">
                                                                          <div className="alert alert-warning" role="alert">
                                                                              <h6 className="alert-heading">Please Note:</h6>

                                                                              <p>{item.valueString ? item.valueString : "N/A"}</p>
                                                                          </div>
                                                                      </div>
                                                                  </div>

                                                                        )
                                                                    })
                                                                ) : null

                                                            }
                                                            {/* {Profile.map((person, i) => {
                                                                    <p>{person.resource.extension[8] !== undefined
                                                                        ? person.resource.extension[8].valueString
                                                                        : 'NO Data Found'}</p>
                                                                })} */}
                                                            {/* <p>   {!isFetching && typeof (Profile[0].resource.extension[8].valueString) !== 'undefined' ? Profile[0].resource.extension[8].valueString : null}</p> */}
                                                            {/* <p>{state.immuneMg}</p> */}
                                                            {/* <p>Please be aware that the vaccination information displayed on this screen relates only to vaccines that were scheduled and/or administered by your treatment centre. Any vaccines administered outside of your treatment centre will not be recorded here</p> */}
                                                        {/* </div>
                                                    </div>
                                                </div> */}
                                                <div className="drive-wrapper drive-grid-view">
                                                    <div className="grid-items-wrapper">
                                                        {
                                                            isGetting && <View style={{ textAlign: 'center', marginBottom: 5 }}><ActivityIndicator size="small" color="#00A1DE" /></View>
                                                        }
                                                        {
                                                            // Resources != null && Resources != undefined && Resources.map((item) => {
                                                            //     return (
                                                            //         <ResourcesHandler />
                                                            //     )
                                                            // })

                                                        Resources && Resources.length ? (
                                                                Resources.map((item) => {
                                                                    return ( 

                                                                        <ResourcesHandler
                                                                            name={item.resource.content.title}
                                                                            responseType={item.resource.content.hasOwnProperty('contentType') ? item.resource.content.contentType === 'PDF' ? 'fa fa-file-pdf-o text-danger' : 'fa fa-link text-warning' : null}
                                                                            contentType={item.resource.content.hasOwnProperty('contentType') ? item.resource.content.contentType === 'PDF' ? 'PDF' : 'URL' : null}
                                                                            contentFlow={item.resource.content.hasOwnProperty('contentType') ? item.resource.content.contentType === 'PDF' ? item.resource.id : item.resource.content.url : null}
                                                                            pdfVisible={pdfVisible}
                                                                            file={file}
                                                                            isMediaByIDData={isMediaByIDData}
                                                                            setPdfVisible={setPdfVisible}
                                                                        />

                                                                    )
                                                                })
                                                            ) : !isGetting && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                                                                <Text style={{ marginTop: 10, }}>No Records Found</Text>
                                                            </View>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer className="footer">

                    </footer>
                </div>

            {/* </div> */}

              
            <Modal
    title="PDF File"
    centered
    open={pdfVisible}
    onOk={() =>{
        dispatch(appServices.gettingMediaByIDClear())
         setPdfVisible(false)}}
    onCancel={() =>{
        dispatch(appServices.gettingMediaByIDClear())
         setPdfVisible(false)}}
    afterClose={() => document.getElementById("showPDF").innerHTML = ""}
    style={{ top: 10, bottom: 90, overflow: "hidden" }}
    width={1000}
    maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} // Change this to your desired opacity and color
>
                    <div
                        style={{
                            border: '1px solid rgba(0, 0, 0, 0.3)',
                            height: '750px',
                        }}
                    >
                        <Viewer fileUrl={file} plugins={[
                            defaultLayoutPluginInstance,
                        ]} />
                    </div>
                    <div className="PDF" id="showPDF">
                    </div>
                    <p id="hee">
                        {isMediaByIDData && <View style={{ justifyContent: 'center', alignItems: 'center' }}><ActivityIndicator size="small" color="#00A1DE" /><Text>Loading. Please wait...</Text></View>}
                    </p>
                </Modal>
        </div>
    )
}


// function mapStateToProps(state) {
//     return {
//         Resources: state.Resources,

//         // Profile: state.Profile,
//     }
// }

// function mapDispatchToProps(disptach) {
//     return {
//         // getProfile: () => disptach(fetchProfileFromApi()),
//         getResources: (pageSize, pageNumber) => disptach(fetchResourcesFromApi(pageSize, pageNumber)),
//         //getMoreResources: (token, pageSize, pageNumber) => disptach(fetchMoreResourcesFromApi(token, pageSize, pageNumber))
//     }
// }

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(ResourcesHome)
export default ResourcesHome
